import { render, staticRenderFns } from "./purchaseAgreement.vue?vue&type=template&id=43c2d89f&scoped=true&"
import script from "./purchaseAgreement.vue?vue&type=script&lang=js&"
export * from "./purchaseAgreement.vue?vue&type=script&lang=js&"
import style0 from "./purchaseAgreement.vue?vue&type=style&index=0&id=43c2d89f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c2d89f",
  null
  
)

export default component.exports